<template>
  <div>
    <div v-if="isLoading" class="container">
      <div class="row">
        <div class="col-12 text-center">
          <fp-loading></fp-loading>
        </div>
      </div>
    </div>
    <div v-else class="container">
      <div class="row">
        <div class="col-12 text-center">
          <img :src="require('../assets/brand.png')" alt="" style="width: 300px" />
        </div>
        <div class="col-12 col-lg-6 offset-lg-3 mt-4">
          <div class="card mb-2">
            <div class="card-body">
              <b>{{ draftApartmentInfo.get("publicId") }}</b> :
              {{ draftApartmentInfo.get("name") }}
            </div>
          </div>
          <!-- <button
            class="btn btn-lg btn-block btn-outline-primary shadow"
            type="button"
            @click="goToLeads()"
          >
            <i class="fas fa-user-friends"></i> ดูข้อมูลผู้สนใจหอพัก
            <span class="badge badge-pill badge-danger" v-if="newLeadBadge">{{
              newLeadBadge
            }}</span>
          </button> -->
          <button class="btn btn-lg btn-block btn-outline-primary shadow" type="button" @click="goToSetting()">
            <i class="fas fa-cog"></i> จัดการข้อมูลโฆษณา
          </button>
          <button class="btn btn-lg btn-block btn-outline-primary shadow" type="button" @click="goToFAQ()">
            <i class="fas fa-question-circle"></i> คำถามที่พบบ่อย
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      apartmentId: this.$route.params.apartmentId,
      draftApartmentInfo: null,
      newLeadBadge: 0,
      isLoading: true,
      currentUser: null,
    };
  },
  async created() {
    // Login
    try {
      let sessionToken = this.$route.query.sessionToken;
      if (
        !this.Parse.User.current() ||
        (this.Parse.User.current() &&
          this.Parse.User.current().getSessionToken() !== sessionToken)
      ) {
        await this.Parse.User.become(sessionToken);
      }
      let user = this.Parse.User.current();
      await user.get("userProfile").fetch();
      this.currentUser = user;
    } catch (error) {
      this.$router.push({ name: "Error", params: { message: "error" } });
    }
    // Init
    if (this.apartmentId && this.currentUser) {
      const Apartment = this.Parse.Object.extend("Apartment");
      let draftApartmentInfoQuery = new this.Parse.Query("DraftApartmentInfo");
      draftApartmentInfoQuery.equalTo(
        "apartment",
        Apartment.createWithoutData(this.apartmentId)
      );
      draftApartmentInfoQuery.select([
        "acceptedIndividual",
        "publicId",
        "name",
      ]);
      let draftApartmentInfo = await draftApartmentInfoQuery.first();
      if (draftApartmentInfo) {
        if (draftApartmentInfo.get("acceptedIndividual")) {
          this.draftApartmentInfo = draftApartmentInfo;
          this.isLoading = false;
          // let leadQuery = new this.Parse.Query("RentiniLead");
          // leadQuery.equalTo("draftApartmentInfo", draftApartmentInfo);
          // leadQuery.notEqualTo("isViewed", true);
          // this.newLeadBadge = await leadQuery.count();
        } else {
          this.goToSetting();
        }
      } else {
        this.goToLandingPage();
      }
    } else {
      this.$router.push({ name: "Error", params: { message: "error" } });
    }
  },
  methods: {
    goToLeads() {
      this.$router.push({
        name: "Leads",
        params: { apartmentId: this.apartmentId },
      });
    },
    goToSetting() {
      this.$router.push({
        name: "ApartmentRegister",
        params: { apartmentId: this.apartmentId },
      });
    },
    goToLandingPage() {
      this.$router.push({
        name: "Landing",
        params: { apartmentId: this.apartmentId },
      });
    },
    goToFAQ() {
      this.$router.push({
        name: "ApartmentFAQ",
        params: { apartmentId: this.apartmentId },
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.container {
  margin-top: 50px;
  margin-bottom: 150px;
}
</style>